<script setup lang="ts">
defineProps<{ data: QuoteProps; template?: 'page' | 'overlay' }>()
</script>

<template>
  <section
    class="px-bleed flex flex-col gap-5 py-4 lg:gap-6 lg:py-5"
    :class="{
      'bg-white': template !== 'page' && template !== 'overlay' && data.theme !== 'light-grey',
      'bg-light-grey': template === 'page' || (template !== 'overlay' && data.theme === 'light-grey'),
    }"
  >
    <blockquote :class="{ 'lg:grid lg:grid-cols-12': template === 'page' }">
      <ElementsPortableTextWrapper
        class="font-display text-xl uppercase font-stretch-expanded lg:text-3xl"
        :class="{ 'lg:col-start-1 lg:col-end-9': template === 'page' }"
        :content="data.quote"
      />
    </blockquote>

    <p class="font-mono text-sm uppercase">
      <cite class="not-italic">{{ data.quotee }}</cite>
    </p>
  </section>
</template>
